import {SegmentProps} from 'modules/segments/types';
import segmentsKeys from 'modules/segments/util/segments-keys';
import React from 'react';
import List from 'shared/layout/list';
import ApiSwitch from 'shared/migration-components/api-switch';
import useProjection from 'shared/migration-hooks/use-projection';

const Segments: React.FC = () => {
  const projection = useProjection<SegmentProps>('segments', [
    'id',
    'name',
    'image',
    'active',
  ]);

  return (
    <List<SegmentProps>
      {...{
        titleBar: {
          title: 'Segmentos',
          actionButton: {title: 'NOVO SEGMENTO', to: 'create'},
        },
        table: {
          url: '/segments',
          projection: {
            ...projection,
            options: [
              'name',
              {
                value: 'active',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      multipart
                      isChecked={row.active}
                      url={`/segments/${row.id}`}
                      queryKey={segmentsKeys.list()}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
            ],
          },
          translatedPropsKey: 'SegmentProps',
        },
        queryKey: segmentsKeys.list(),
      }}
    />
  );
};

export default Segments;
